import { type BaseRowData } from '@adv-frontend/data-provider';
import { type GridRow } from '@adv-frontend/grid';

type SelectableSubRow = Pick<GridRow<BaseRowData>, 'id' | 'original'> & {
    /** Вложенные строки текущей строки. */
    subRows: SelectableSubRow[];
};

/**
 * Возвращает идентификаторы загруженных подстрок, доступных для массового выбора.
 * Стабы flow-based дата-провайдера не должны попадать в бизнес-запросы как идентификаторы сущностей.
 * @kind helper
 * @param subRows Вложенные строки грида.
 * @returns Идентификаторы загруженных подстрок.
 */
export const getSelectableSubRowsIds = (subRows: SelectableSubRow[]): string[] => {
    const selectableIds: string[] = [];

    const collectSelectableIds = (rows: SelectableSubRow[]) => {
        rows.forEach((row) => {
            if (row.original.status !== 'loaded') {
                return;
            }

            selectableIds.push(row.id);
            collectSelectableIds(row.subRows);
        });
    };

    collectSelectableIds(subRows);

    return selectableIds;
};
